import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AlterarSenhaRoutingModule } from "./alterar-senha-routing.module";
import { AlterarSenhaComponent } from "./alterar-senha.component";
import { AntdModule } from "../../antd.module";
import { ReactiveFormsModule } from "@angular/forms";
import { InputMaskModule } from "@ngneat/input-mask";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
    declarations: [AlterarSenhaComponent],
    imports: [CommonModule, AlterarSenhaRoutingModule, AntdModule, ReactiveFormsModule, InputMaskModule, SharedModule],
})
export class AlterarSenhaModule {}
